import { useAppStateSelector } from '../useAppStateSelector'
import { LoadingStates } from '@dashboard/lib/types'
import { useCallback, useEffect } from 'react'
import { useAppDispatch } from '../useAppDispatch'
import {
  getUserCriteria,
  UserCriteriaResponse,
} from '@dashboard/store/actions/user/criteria'

interface Props {
  state: LoadingStates
  result: UserCriteriaResponse | null
  fetch: () => void
}

export function useUserCriteria(type: string): Props {
  const { criteriaStates, criteriaResults } = useAppStateSelector(
    state => state.user,
  )
  const state = criteriaStates[type] || 'default'
  const result = criteriaResults[type] || null
  const dispatch = useAppDispatch()
  const fetch = useCallback(
    () => dispatch(getUserCriteria(type)),
    [type, dispatch],
  )

  useEffect(() => {
    if (state === 'default') fetch()
  }, [fetch, type, state])

  return {
    state,
    result,
    fetch,
  }
}
